import { ToggleGroup } from '@policygenius/mortar';
import React, { useMemo } from 'react';

import { FieldRenderProps } from 'forms/types';
import getErrorMessage from 'forms/utils/getErrorMessage';

import styles from '../form-inputs.module.scss';
import { BaseToggleFieldProps, ToggleChoice } from './types';
import { fromString, toString } from './utils';

export type ToggleFieldProps<Value = boolean> = BaseToggleFieldProps<Value> &
  FieldRenderProps<Value>;

const DEFAULT_CHOICES: Array<ToggleChoice<any>> = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

function ToggleField<Value = boolean>({
  input,
  meta,
  onChange,
  choices = DEFAULT_CHOICES,
  ...props
}: ToggleFieldProps<Value>) {
  const _onChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const value = fromString(event.target.value) as Value;

    onChange?.(value);

    return input.onChange(value);
  };

  const options = useMemo<NonNullable<ToggleGroup.Props['options']>>(
    () =>
      choices.map((choice) => ({
        label: choice.label,
        value: toString(choice.value),
      })),
    [choices]
  );

  return (
    <div className={styles['field-container']}>
      <ToggleGroup
        {...input}
        {...props}
        value={toString(input.value)}
        errorMessage={getErrorMessage(meta)}
        onChange={_onChange}
        options={options}
        showGroupLabel
      />
    </div>
  );
}

export default ToggleField;
